import { render, staticRenderFns } from "./footerAuthor.vue?vue&type=template&id=2f3fe960&scoped=true"
import script from "./footerAuthor.vue?vue&type=script&lang=js"
export * from "./footerAuthor.vue?vue&type=script&lang=js"
import style0 from "./footerAuthor.vue?vue&type=style&index=0&id=2f3fe960&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3fe960",
  null
  
)

export default component.exports